(function () {
  function removeInvalidRestockButtons() {
    document.querySelectorAll('#shopify-section-slideshow > .notify-bis-wrapper').forEach(function (wrapper) {
      wrapper.remove();
    });
  }

  function positionRestockButtons() {
    removeInvalidRestockButtons();

    document.querySelectorAll('.product-item').forEach(function (card) {
      var wrappers = card.querySelectorAll('.notify-bis-wrapper');
      var actions = card.querySelector('.product-item__action-list');

      if (!wrappers.length || !actions) {
        return;
      }

      wrappers.forEach(function (wrapper, index) {
        if (index > 0) {
          wrapper.remove();
          return;
        }

        var button = wrapper.querySelector('.alertme-btn');

        if (button) {
          button.classList.add('product-item__action-button', 'button--small', 'button--primary');
          button.classList.remove('button--disabled');
          button.disabled = false;
          if (button.textContent.trim() !== 'Avise-me') {
            button.textContent = 'Avise-me';
          }
        }

        if (wrapper.parentElement !== actions) {
          actions.insertBefore(wrapper, actions.firstChild);
        }
      });

      card.classList.add('bis-card-done');
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', positionRestockButtons);
  } else {
    positionRestockButtons();
  }

  new MutationObserver(positionRestockButtons).observe(document.documentElement, {
    childList: true,
    subtree: true
  });
})();
